export const standardLanguageFallbacks: Record<string, Array<string>> = {
  "en-GB": ["en"],
  "nb-NO": ["no", "en"],
  "nn-NO": ["nb-NO", "no", "en"],
  nb: ["no", "en"],
  nn: ["no", "en"],
};
